'use strict';

const jQuery = require('jquery');

const ContentRepository = require('./../repository/ContentRepository');
const ContentManager = require('./../component/ContentManager');
const container = require('./../../../core/container');
const mediator = require('./../../../core/mediator');
const translator = require('./../../../core/translator');

const contentSetEditToolbarTpl = require('./../template/contentset_edit_toolbar.hbs');

module.exports.init = function() {
  let contentNotEditable = require('./../config').settings.contents_not_editable;
  let $body = jQuery('body');

  $body.on('mouseenter', '.cloudcontentset', function() {
    if (container.get('ui_status') === 'disabled' || !container.get('isAllowedTo')('CREATE_CONTENT')) {
      return true;
    }

    let $current = jQuery(this);
    let cloudContentSet = ContentManager.getContentByNode($current);
    let $div = jQuery('<div class="btn-row-settings"><a class="btn-plugin row-settings"><i class="icon icon-setting"></i></a><span>' + translator.translate('background_options') + '</span></div>');

    if ($current.find('.cloud-resizing').length || $current.find('.btn-row-settings').length || jQuery('body').hasClass('prevent-plugins')) {
      return;
    }

    $div.publish('row-settings:click', cloudContentSet);

    $current.prepend($div);
  });

  $body.on('mouseleave', '.cloudcontentset', function() {
    if (container.get('ui_status') === 'disabled') {
      return true;
    }

    jQuery(this).find('.btn-row-settings').remove();
  });

  $body.on('mouseenter', '.bb-content:not(.rootContentSet):not(.container)', function(event) {
    if (container.get('ui_status') === 'disabled') {
      return true;
    }

    let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

    if (null !== content &&
      content.isEditable() &&
      -1 === contentNotEditable.indexOf(content.type) &&
      !jQuery('body').hasClass('prevent-plugins')) {
      mediator.publish('content:mouseover', content);
    }
  });

  $body.on('mouseleave', '.bb-content', function(event) {
    let $toElement = jQuery(event.toElement);
    let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

    if (null !== content && content.isEditable() &&
      -1 === contentNotEditable.indexOf(content.type) &&
      !jQuery('body').hasClass('prevent-plugins')) {
      if ($toElement.parents('.toolbar-plugin:first').length === 0 && !jQuery(this).hasClass('fixed')) {
        mediator.publish('content:mouseout', content);
      }
    }
  });

  $body.on('mouseenter', '.cloud-dnd', function(event) {
    if (container.get('ui_status') === 'disabled' || container.get('ui_insert_content') === 'disabled') {
      return true;
    }

    let $target = jQuery(event.target);
    let toolbar;

    if ($target.hasClass('horizontal') && !jQuery('body').hasClass('prevent-plugins')) {
      jQuery('.cloud-insert').each(function() {
        let $current = jQuery(this);

        if (!$current.hasClass('fixed')) {
          $current.remove();
        }
      });

      ContentRepository.findCategories().done(function(categories) {
        toolbar = jQuery(contentSetEditToolbarTpl());

        toolbar.publish('content:plugin:plus', {'categories': categories});

        $target.append(toolbar);
      });
    }
  });

  $body.on('mouseleave', '.cloud-dnd', function(event) {
    if (container.get('ui_status') === 'disabled') {
      return true;
    }

    let $toElement = jQuery(event.toElement);
    let $currentTarget = jQuery(event.currentTarget);
    let $toolbar;

    if ($currentTarget.hasClass('horizontal') && !jQuery('body').hasClass('prevent-plugins')) {
      if ($toElement.parents('.cloud-insert:first').length === 0) {
        $toolbar = $currentTarget.find('.cloud-insert');

        if (!$toolbar.hasClass('fixed') && !$currentTarget.hasClass('force-fixed')) {
          $toolbar.remove();
        }
      }
    }
  });
};
